import React from 'react';

/* Wax-seal sovereign oath: gold seal rim, violet core, three pillar flames. */
export const OathTileIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <defs>
      <radialGradient id="oathCore" cx="50%" cy="40%" r="60%">
        <stop offset="0%" stopColor="#B978FF" />
        <stop offset="100%" stopColor="#3A0F5E" />
      </radialGradient>
      <linearGradient id="oathRim" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFE9A0" />
        <stop offset="100%" stopColor="#8B6B2F" />
      </linearGradient>
    </defs>
    <path d="M12 1.8l2.1 1.6 2.6-.4 1 2.4 2.4 1-.4 2.6 1.6 2.1-1.6 2.1.4 2.6-2.4 1-1 2.4-2.6-.4L12 22.2l-2.1-1.6-2.6.4-1-2.4-2.4-1 .4-2.6L2.7 12l1.6-2.1-.4-2.6 2.4-1 1-2.4 2.6.4z"
      fill="url(#oathRim)" stroke="#D4AF37" strokeWidth="0.4" />
    <circle cx="12" cy="12" r="6.4" fill="url(#oathCore)" stroke="#FFE9A0" strokeWidth="0.5" />
    <path d="M12 7.6c1 1.4 1.6 2.4 1.6 3.4a1.6 1.6 0 01-3.2 0c0-1 .6-2 1.6-3.4z" fill="#FFE9A0" />
    <path d="M9 10.4c.6.9 1 1.5 1 2.1a1 1 0 01-2 0c0-.6.4-1.2 1-2.1z" fill="#5BE08A" />
    <path d="M15 10.4c.6.9 1 1.5 1 2.1a1 1 0 01-2 0c0-.6.4-1.2 1-2.1z" fill="#5DD4FF" />
    <path d="M8.2 15.2h7.6" stroke="#FFE9A0" strokeWidth="0.9" strokeLinecap="round" />
  </svg>
);

export default OathTileIcon;
